import { ROUTES } from 'constants/routes';

export const PARASHARI_FOUNDATION_COURSE_IDS = new Set([
  'c0000000-0000-0000-0000-000000000001',
  'course-1',
]);

export const JAIMINI_SCHOOL_IDS = new Set([
  'school-2',
  'b0000000-0000-0000-0000-000000000002',
]);

export const JAIMINI_COURSE_IDS = new Set([
  'course-3',
  'c0000000-0000-0000-0000-000000000002',
]);

export const BNN_SCHOOL_IDS = new Set([
  'school-4',
  'b0000000-0000-0000-0000-000000000004',
]);

export const BNN_COURSE_IDS = new Set([
  'course-4',
  'c0000000-0000-0000-0000-000000000004',
]);

/** @deprecated Use JAIMINI_COURSE_IDS */
export const JAIMINI_BRIDGE_COURSE_IDS = JAIMINI_COURSE_IDS;

type CourseRouteInput = {
  id: string;
  title?: string;
  schoolSlug?: string;
  schoolId?: string;
};

function titleLooksLikeJaimini(title?: string): boolean {
  const normalized = (title ?? '').toLowerCase();
  if (!normalized.includes('jaimini')) return false;
  if (normalized.includes('bridge')) return false;
  if (normalized.includes('parashari to jaimini')) return false;
  return true;
}

function titleLooksLikeBnn(title?: string): boolean {
  const normalized = (title ?? '').toLowerCase();
  return normalized.includes('bnn') || normalized.includes('nandi nadi') || normalized.includes('bhrigu nandi');
}

export function isBnnCourse(course: CourseRouteInput): boolean {
  if (course.schoolSlug === 'bnn') return true;
  if (course.schoolId && BNN_SCHOOL_IDS.has(course.schoolId)) return true;
  if (BNN_COURSE_IDS.has(course.id)) return true;
  if (titleLooksLikeBnn(course.title)) return true;
  return false;
}

export function isJaiminiCourse(course: CourseRouteInput): boolean {
  if (isBnnCourse(course)) return false;
  if (course.schoolSlug === 'jaimini') return true;
  if (course.schoolId && JAIMINI_SCHOOL_IDS.has(course.schoolId)) return true;
  if (JAIMINI_COURSE_IDS.has(course.id)) return true;
  if (titleLooksLikeJaimini(course.title)) return true;
  return false;
}

export function isParashariFoundationCourse(course: CourseRouteInput): boolean {
  if (isJaiminiCourse(course)) return false;
  if (isBnnCourse(course)) return false;
  return (
    course.schoolSlug === 'parashari' ||
    course.title === 'Parashari Foundation' ||
    PARASHARI_FOUNDATION_COURSE_IDS.has(course.id)
  );
}

/** @deprecated Use isJaiminiCourse */
export function isJaiminiBridgeCourse(course: CourseRouteInput): boolean {
  return isJaiminiCourse(course);
}

export function schoolEntryHref(slug: string): string {
  if (slug === 'parashari') {
    return ROUTES.PARASHARI_LEARN;
  }
  if (slug === 'jaimini') {
    return ROUTES.JAIMINI_LEARN;
  }
  if (slug === 'bnn') {
    return ROUTES.BNN_LEARN;
  }
  if (slug === 'kp') {
    return ROUTES.KP_LEARN;
  }
  if (slug === 'lal-kitab') {
    return ROUTES.LAL_KITAB_LEARN;
  }
  if (slug === 'numerology') {
    return ROUTES.NUMEROLOGY_LEARN;
  }
  if (slug === 'surya-siddhanta') {
    return ROUTES.SURYA_SIDDHANTA_LEARN;
  }
  if (slug === 'panchang') {
    return ROUTES.PANCHANG_LEARN;
  }
  if (slug === 'vastu') {
    return ROUTES.VASTU_LEARN;
  }
  if (slug === 'swara-vigyan') {
    return ROUTES.SWARA_VIGYAN_LEARN;
  }
  if (slug === 'yantra-vidya') {
    return ROUTES.YANTRA_VIDYA_LEARN;
  }
  if (slug === 'tantra') {
    return ROUTES.TANTRA_LEARN;
  }
  return ROUTES.SCHOOL_DETAIL.replace(':slug', slug);
}

export function courseEntryHref(course: CourseRouteInput): string {
  if (isBnnCourse(course)) {
    return ROUTES.BNN_LEARN;
  }
  if (isJaiminiCourse(course)) {
    return ROUTES.JAIMINI_LEARN;
  }
  if (isParashariFoundationCourse(course)) {
    return ROUTES.PARASHARI_LEARN;
  }
  return ROUTES.COURSE_DETAIL.replace(':courseId', course.id);
}
